// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 5.5H13M3 10.5H13M6.75 2.5L5.25 13.5M10.75 2.5L9.25 13.5',
];
